<template>
  <div class="od-card-container">
    <div class="odc-header-container">
      <div class="odc-header">
        Payment Method
      </div>
    </div>
    <div class="odc-body-container flex-row align-center">
      <div class="pmi-image-container">
        <PaymentMethodIcon
          :paymentMethod="invoicePaymentMethod"
        />
      </div>
      <div
        v-if="invoicePaymentMethod.bank_account"
        class="flex-column margin-left-4"
      >
        <div class="pmi-header">
          {{ invoicePaymentMethod.bank_account.bank_name }}
        </div>
        <div class="pmi-body">
          Ending in... {{ invoicePaymentMethod.bank_account.last4 }}
        </div>
      </div>
      <div
        v-else-if="invoicePaymentMethod.card"
        class="flex-column margin-left-4"
      >
        <div class="pmi-header">
          {{ invoicePaymentMethod.card.brand.toUpperCase() }}
        </div>
        <div class="pmi-body">
          Ending in... {{ invoicePaymentMethod.card.last4 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

import PaymentMethodIcon from '../shared/PaymentMethodIcon.vue';

export default {
  name: 'InvoicePaymentMethod',
  components: {
    PaymentMethodIcon,
  },
  mixins: [partnerReviewMixin],
};
</script>
